export default __webpack_public_path__ + "static/media/Consultation.8368c358.svg";